// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-ReGlr";
var _4 = "content-20sl4";
var _5 = "error__description-2jD4u";
var _6 = "error__code-gubzC";
var _7 = "button-3Yokg";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "content", _5 as "error__description", _6 as "error__code", _7 as "button" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "content": _4, "error__description": _5, "error__code": _6, "button": _7 }
